import {useUserDevice} from "@pg-mono/user-device";

import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {useMultiLeadReport} from "../../hooks/multi_lead/use_multi_lead_report";
import {RecommendedOfferApplicationsType} from "../../hooks/multi_lead/use_track_recommended_offers_application";
import {useLeadData} from "../../hooks/use_lead_data";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

interface IProps {
    originalApplicationResponse: IApplicationData | null;
    sourceSection: ApplicationSourceSection;
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    customSourceSection?: string;
    handleModalClose: () => void;
    handleSetMultiLeadSummaryStep: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        customSourceSection
    } = props;

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const {isMobile} = useUserDevice();
    const currentViewType = useAppSelector((store) => store.viewType.current);
    const {modalClose: reportModalClose} = useMultiLeadReport();
    const originalApplication = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined}) ?? undefined;
    const multiLeadProperty = originalApplication?.property?.detail ?? null;
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const onSimpleVariantSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: hasVerifiedPhone && shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        reportModalClose(recommendationType, currentViewType);
        handleModalClose();
    };

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </ApplicationMultiLeadWrapper>
    );
};
import {useUserDevice} from "@pg-mono/user-device";

import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {useMultiLeadReport} from "../../hooks/multi_lead/use_multi_lead_report";
import {RecommendedOfferApplicationsType} from "../../hooks/multi_lead/use_track_recommended_offers_application";
import {useLeadData} from "../../hooks/use_lead_data";
import {useLeadRequiredParams} from "../../hooks/use_lead_required_params";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

interface IProps {
    originalApplicationResponse: IApplicationData | null;
    sourceSection: ApplicationSourceSection;
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    customSourceSection?: string;
    handleModalClose: () => void;
    handleSetMultiLeadSummaryStep: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        customSourceSection
    } = props;

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const {isMobile} = useUserDevice();
    const currentViewType = useAppSelector((store) => store.viewType.current);
    const {modalClose: reportModalClose} = useMultiLeadReport();
    const originalApplication = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined}) ?? undefined;
    const multiLeadProperty = originalApplication?.property?.detail ?? null;
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const onSimpleVariantSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: hasVerifiedPhone && shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        reportModalClose(recommendationType, currentViewType);
        handleModalClose();
    };

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </ApplicationMultiLeadWrapper>
    );
};
